module.exports = __webpack_public_path__ + "section/map/img/marker.png?hash=2cc9d4f39ec6b88f772363ae9ef86646"


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/asset-loader!./LeLab.LogAlto.Web/src/modules/section/map/img/marker.png
 ** module id = 23
 ** module chunks = 0 1
 **/